/**
 * Fonction servant à récupérer la configuration de Matomo
 * à partir de la variable d'environnement REACT_APP_MATOMO_CONTAINER_URL
 *
 * @returns {function} - Fonction de configuration de Matomo
 */
export const getMatomoConfig = () => {
  const containerUrl = process.env.REACT_APP_MATOMO_CONTAINER_URL;

  if (!containerUrl) return null;
  else {
    return () => {
      var _mtm = (window._mtm = window._mtm || []);
      _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
      var d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.async = true;
      g.src = `${containerUrl}`;
      s.parentNode.insertBefore(g, s);
    };
  }
};
